import { render } from "./ziIconSprite.vue?vue&type=template&id=585f4d22&scoped=true"
import script from "./ziIconSprite.vue?vue&type=script&lang=js"
export * from "./ziIconSprite.vue?vue&type=script&lang=js"

import "./ziIconSprite.vue?vue&type=style&index=0&id=585f4d22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585f4d22"]])

export default __exports__